module.exports = __webpack_public_path__ + "img/file-check.21257783.svg";